import { ErrorWrapper } from "../../base/gui/controls/Form"
import { StyledErrorBanner } from "./Style"

export const ErrorBanner = () => {
    return (
        <ErrorWrapper Element={({error}) => <StyledErrorBanner>{error}</StyledErrorBanner>}/>
    )
}